export default "__VITE_ASSET__BJst3316__"